/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useEffect, useState, useContext, useRef, useMemo } from 'react';
// import { isLogged } from 'selectors/auth.selector';
import Cookie from 'universal-cookie';
import moment from 'moment';
import * as MensGrales from 'constants/MensajesGenerales';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ExcelButton, Table, Tooltip, HeaderPage, NumericInput } from 'components';
import {
  getUsersNotRFAndAdmin,
  lockUser,
  getUserLdap,
  getCatalogsToFormUsers,
  postUser
} from 'actions/users.actions';
import { UsuariosContext } from 'contexts/UsuariosContext';
import {
  Row,
  Col,
  DatePicker,
  Space,
  Input,
  ConfigProvider,
  Divider,
  Card,
  Form,
  Select,
  Checkbox,
  message,
  Skeleton
} from 'antd';
import { downloadExcelUsr } from 'actions/files.actions';
import { base64toBlob } from 'utils/file';
import { getRolNameById } from 'utils/usuarios';
import {
  FormOutlined,
  CheckCircleOutlined,
  StopOutlined,
  ExclamationCircleFilled
} from '@ant-design/icons';
import dataUserImg from 'assets/images/User/Datos_usuario.svg';
import esES from 'antd/locale/es_ES';
import 'dayjs/locale/es';
import './UserAccount.scss';
import './TableUser.scss';
import { useDebounce } from 'hooks/useDebounce';
import { filterList } from 'utils/filterList';
import ModalUser from './ModalUser';

function UserAccount() {
  const dispatch = useDispatch();
  // const { loading } = useSelector(selectUsersState);
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const [usuariosList, setUsuariosList] = useState([]);
  const [valueMostrar, setValueMostrar] = useState(10);
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  // const [usuariosListBase, setUsuariosListBase] = useState([]);}
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState({});
  const [usuariosFiltro, setUsuariosFiltro] = useState({});
  const [isVisibleCard, setIsVisibleCard] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [rolValue, setRolValue] = useState('');
  const [loadingCard, setLoadingCard] = useState(true);
  const { counter, setCounter } = useContext(UsuariosContext);
  const [usuarioLdap, setUsuarioLdap] = useState(null);
  const [asociaciones, setAsociaciones] = useState([]);
  const [estados, setEstados] = useState([]);
  const [edosNotOC, setEdosNotOC] = useState([]);
  const [edosTodos, setEdosTodos] = useState([]);
  const [sujObligados, setSujObligados] = useState([]);
  const [cmonitoreos, setCmonitoreos] = useState([]);
  const [disabledNoEmp, setDisabledNoEmp] = useState(false);
  const [disabledUsuario, setDisabledUsuario] = useState(false);
  const [rolNameRow, setRolNameRow] = useState('');
  const [form] = Form.useForm();
  const [formRF] = Form.useForm();
  const [formBuscar] = Form.useForm();
  const placement = 'topRight';
  const [locale] = useState(esES);
  const dateFormat = 'DD MMMM YYYY';
  const showTotal = (total) => `Mostrando ${valueMostrar} registros por página`;
  const [messageApi, contextHolder] = message.useMessage();
  let tokken = null;
  const coki = new Cookie();
  const [arrPuestos, setArrPuestos] = useState([]);
  const [valueFiltroNumEmp, setValueFiltroNumEmp] = useState();
  const filtersRef = useRef({});
  const { data: usuario } = useSelector((state) => state.validarUsuario);

  const DEBOUNCE_TIME_FILTER = 2000;
  const applyFilter = useDebounce((fields) => setSearchValue(fields), DEBOUNCE_TIME_FILTER);

  const handleChangeFilter = ({ target }) => {
    if (target !== undefined && target !== null) {
      const { value, name } = target;
      filtersRef.current[name] = value;
      applyFilter({ ...filtersRef.current });
      // setLoading(true);
    }
  };

  const handleChangeFilterNumber = (value) => {
    if (value !== undefined) {
      setValueFiltroNumEmp(value);
      const numberFiltro = value === '' ? null : value;
      filtersRef.current.numEmpleado = numberFiltro;
      applyFilter({ ...filtersRef.current });
      // setLoading(true);
    }
  };

  const handleChangeDateFilter = (date) => {
    filtersRef.current.fechaHoraAlta = date;
    applyFilter({ ...filtersRef.current });
    // setLoading(true);
  };

  const filteredList = useMemo(() => {
    if (usuariosList !== null) {
      // setLoading(false);
      const filteredData = usuariosList.filter((row) => {
        return true;
      });
      return filteredData;
    }
    return null;
  }, [usuariosList]);

  const dataList = useMemo(() => {
    // setLoading(false);
    return filterList(filteredList, searchValue);
  }, [filteredList, searchValue]);

  async function getUsuarios() {
    setLoading(true);
    const respuesta = await dispatch(getUsersNotRFAndAdmin());
    if (respuesta && respuesta.usuariosResponse?.data.code === 200) {
      if (respuesta.usuariosResponse.data?.usuarios) {
        setUsuariosList(respuesta.usuariosResponse.data.usuarios);
        const arrUsuarios = respuesta.usuariosResponse.data.usuarios;
        for (let i = 0; i < arrUsuarios.length; i += 1) {
          if (arrUsuarios[i].puesto && arrUsuarios[i].puesto !== '') {
            if (!arrPuestos.includes(arrUsuarios[i].puesto)) {
              arrPuestos.push(arrUsuarios[i].puesto);
            }
          }
        }
        setArrPuestos(arrPuestos);
      }
    }
    setLoading(false);
  }

  async function getCatalogsToForm() {
    const respuesta = await dispatch(getCatalogsToFormUsers());
    if (respuesta && respuesta?.response?.data.code === 200) {
      const tempEdosNotOC = [];
      setAsociaciones(respuesta.response.data.asociaciones);
      setEstados(respuesta.response.data.estados);
      tempEdosNotOC.push({
        idEstado: -1,
        nombreEstado: 'TODOS'
      });
      for (let i = 0; i < respuesta.response.data.estados.length; i += 1) {
        tempEdosNotOC.push(respuesta.response.data.estados[i]);
      }
      setEdosNotOC(tempEdosNotOC);
      setSujObligados(respuesta.response.data.sujObligados);
      setCmonitoreos(respuesta.response.data.cmonitoreos);
    } else if (respuesta?.causa !== undefined) {
      messageApi.error(respuesta.causa);
    }
  }

  useEffect(() => {
    getUsuarios();
  }, [counter]);

  useEffect(() => {
    getCatalogsToForm();
  }, [0]);

  useEffect(() => {
    tokken = coki.get('JWT-TOKEN-SIMAC');
  }, [0]);

  async function handleLockUser(value) {
    tokken = coki.get('JWT-TOKEN-SIMAC');
    const respuesta = await dispatch(
      lockUser({
        idUsuario: value,
        token: tokken
      })
    );
    if (respuesta) {
      setCounter(counter + 1);
    } else {
      message.error('Ocurrió un error al validar sesión.');
    }
  }

  function validaNumEmpleado(numEmp) {
    if (numEmp === null) {
      return 'S/N';
    }
    return numEmp;
  }

  const FilterByNoEmpleado = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span>No. de empleado</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <NumericInput
            onChangeInput={handleChangeFilterNumber}
            value={valueFiltroNumEmp}
            allowClear
            name="numEmpleado"
          />
        </Col>
      </Row>
    </>
  );

  const FilterByUsuario = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span>Usuario</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Input
            placeholder="Filtra"
            disabled={usuariosList === null || usuariosList.length === 0}
            allowClear
            name="aliasUsuario"
            onChange={handleChangeFilter}
          />
        </Col>
      </Row>
    </>
  );

  const FilterByNombre = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span>Nombre (s)</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Input
            placeholder="Filtra"
            disabled={usuariosList === null || usuariosList.length === 0}
            allowClear
            onChange={handleChangeFilter}
            name="nombre"
          />
        </Col>
      </Row>
    </>
  );

  const FilterByEmail = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span>Correo electrónico</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Input
            placeholder="Filtra"
            disabled={usuariosList === null || usuariosList.length === 0}
            allowClear
            onChange={handleChangeFilter}
            name="correo"
          />
        </Col>
      </Row>
    </>
  );

  const FilterByFecha = (
    <>
      <Row className="estiloTituloTabla">
        <Col span={24}>
          <span>Fecha de asignación</span>
        </Col>
      </Row>
      <Row className="input-tabla">
        <Col span={24}>
          <Space direction="vertical">
            <DatePicker
              disabled={usuariosList === null || usuariosList.length === 0}
              locale={locale}
              onChange={handleChangeDateFilter}
              name="fechaHora"
              placement={placement}
              placeholder=""
              format={dateFormat}
            />
          </Space>
        </Col>
      </Row>
    </>
  );

  const columns = [
    {
      title: FilterByNoEmpleado,
      key: 'numEmpleado',
      dataIndex: 'numEmpleado',
      width: '11%',
      className: 'my-column-tbl',
      render: (record) => validaNumEmpleado(record)
    },
    {
      title: FilterByUsuario,
      dataIndex: 'aliasUsuario',
      width: '9%',
      className: 'my-column-tbl',
      key: 'aliasUsuario'
    },
    {
      title: FilterByNombre,
      dataIndex: 'nombre',
      width: '24%',
      className: 'my-column-tbl',
      key: 'nombre',
      render: (text, record) => (
        <span
          key={text}>{`${record.nombre} ${record.apellidoPaterno} ${record.apellidoMaterno}`}</span>
      )
    },
    {
      title: FilterByEmail,
      dataIndex: 'correo',
      width: '15%',
      key: 'correo'
    },
    {
      title: 'Rol',
      dataIndex: 'listaRolesUsuario',
      key: 'rol',
      filters: [
        {
          text: 'Móvil',
          value: 1
        },
        {
          text: 'Captura',
          value: 3
        },
        {
          text: 'Consulta',
          value: 4
        },
        {
          text: 'Validador',
          value: 5
        },
        {
          text: 'Móvil - Web',
          value: 6
        }
      ],
      onFilter: (value, record) =>
        record.listaRolesUsuario.find((e) => e.id.idSistema === 1)?.idRol === value,
      width: '9%',
      className: 'my-column-tbl',
      render: (text, record) => (
        <span key={text}>
          {record.listaRolesUsuario.find((e) => e.id.idSistema === 1)
            ? getRolNameById(record.listaRolesUsuario.find((e) => e.id.idSistema === 1).idRol)
            : 'N/A'}
        </span>
      )
    },
    {
      title: 'Puesto',
      dataIndex: 'puesto',
      filters: arrPuestos.map((obj) => ({ text: obj, value: obj })),
      onFilter: (value, record) => record.puesto === value,
      width: '11%',
      className: 'my-column-tbl',
      key: 'puesto'
    },
    {
      title: FilterByFecha,
      dataIndex: 'fechaHoraAlta',
      width: '14%',
      className: 'my-column-tbl',
      key: 'fechaHoraAlta',
      render: (_text, record) => (
        <span>{`${moment(record.fechaHoraAlta).format('DD MMMM yyyy hh:mm a')}`}</span>
      )
    },
    {
      title: 'Acciones',
      key: 'acciones',
      align: 'center',
      className: 'my-column-tbl',
      render: (_text, record) => {
        const isItself = usuario.name === record.aliasUsuario;
        return (
          <div className="column-acciones">
            <Tooltip title="Editar" class="tooltip-acciones" placement="topLeft">
              <Button
                shape="circle"
                className="btnTblAccion"
                icon={<FormOutlined className="icons-tbl-users" />}
                onClick={() => {
                  const idRolSimac = record.listaRolesUsuario.find(
                    (e) => e.id.idSistema === 1
                  ).idRol;
                  setUserToEdit(record);
                  setIsModalOpen(true);
                  setRolNameRow(
                    getRolNameById(record.listaRolesUsuario.find((e) => e.id.idSistema === 1).idRol)
                  );
                }}
                disabled={isItself}
              />
            </Tooltip>
            <Button
              shape="circle"
              className="btnTblAccion"
              icon={
                record.estatus === 1 ? (
                  <Tooltip title="Bloquear" class="tooltip-acciones" placement="topLeft">
                    <CheckCircleOutlined style={{ color: '#c12b7d', fontSize: '20px' }} />
                  </Tooltip>
                ) : (
                  <Tooltip title="Desbloquear" className="tooltip-acciones" placement="topLeft">
                    <StopOutlined rotate={90} style={{ color: '#c12b7d', fontSize: '20px' }} />
                  </Tooltip>
                )
              }
              onClick={() => handleLockUser(record.idUsuario)}
              disabled={isItself}
            />
          </div>
        );
      }
    }
  ];

  const handleDownloadExcel = async () => {
    setDownloadingExcel(true);
    const { success, response } = await dispatch(downloadExcelUsr({ usuario: usuariosList }));
    if (response !== null && response !== undefined && success) {
      if (response.data.code === 200) {
        if (response.data.excel64) {
          const url = window.URL.createObjectURL(
            base64toBlob(response.data.excel64.base64, response.data.excel64.tipo)
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', response.data.excel64.nombre);
          link.click();
          setDownloadingExcel(false);
        }
      }
    }
    setDownloadingExcel(false);
  };

  const onLimpiar = () => {
    formBuscar.resetFields();
    setDisabledNoEmp(false);
    setDisabledUsuario(false);
    form.resetFields();
    formRF.resetFields();
    setRolValue('');
    setIsVisibleCard(false);
  };

  const onCancelar = () => {
    form.resetFields();
  };

  const onBuscar = async (value) => {
    form.resetFields();
    if (String(value.usuario).length > 0) {
      setIsVisibleCard(true);
      setLoadingCard(true);
      setRolValue('');
      const parameter = {
        usuario: value.usuario
      };
      const { success, response } = await dispatch(getUserLdap(parameter));
      if (success && response?.data.code === 200) {
        console.log('response', response.data.usuarioLDAP.rolesLdap);
        if (response.data.usuarioLDAP) {
          const rolesSimac = response.data.usuarioLDAP.rolesLdap.filter((e) => e.includes('SIMAC'));
          setRolValue(rolesSimac.length > 0 ? rolesSimac[0] : '');
          setUsuarioLdap(response.data.usuarioLDAP);
          setLoadingCard(false);
          setRolValue((prev) => {
            return prev;
          });
        } else {
          messageApi.info('Usuario no encontrado.');
          setIsVisibleCard(false);
        }
      } else {
        messageApi.info('Usuario no encontrado.');
        setIsVisibleCard(false);
      }
    } else {
      /* empty */
    }
  };

  const onFinishAsigEnc = async (values) => {
    const arrIdsEdos = [];
    if (values.estRegional === 'TODOS') {
      for (let i = 1; i < edosNotOC.length; i += 1) {
        arrIdsEdos.push(edosNotOC[i].idEstado);
      }
      // eslint-disable-next-line no-param-reassign
      values.estRegional = arrIdsEdos;
    }
    if (values.checkOficinas) {
      values.estRegional.unshift(0);
    }
    const userData = JSON.parse(JSON.stringify(values));
    userData.usuarioLdap = usuarioLdap;
    tokken = coki.get('JWT-TOKEN-SIMAC');
    const { success, response } = await dispatch(
      postUser({
        dtoPostUser: userData,
        token: tokken
      })
    );
    if (success && response?.data.code === 200) {
      onLimpiar();
      setCounter(counter + 1);
      messageApi.success('Guardado exitoso');
    } else if (response?.causa !== undefined) {
      messageApi.error(response.causa);
    } else {
      messageApi.error(MensGrales.MAV1_2);
    }
  };

  const handleChangeEstReg = (value) => {
    if (String(value).includes('-1')) {
      form.setFieldsValue({ estRegional: 'TODOS' });
      setEdosTodos(edosNotOC);
    } else {
      setEdosTodos([]);
    }
  };

  return (
    <div className="userAccount-container">
      {contextHolder}
      <HeaderPage
        section=""
        section2="Asignar usuario"
        title="Asignar usuario"
        header="Selecciona al menos un campo para realizar la búsqueda y asignar privilegios."
      />
      <section className="section-search-usr">
        <Form
          id="formSearch"
          layout="vertical"
          form={formBuscar}
          className="card-form"
          onFinish={onBuscar}>
          <Row gutter={[10, 24]} style={{ width: '100%' }}>
            <Col span={6}>
              <Form.Item name="usuario" label="Usuario:" className="card-formitem">
                <Input
                  maxLength={25}
                  style={{ width: '90%' }}
                  disabled={disabledUsuario}
                  onChange={(e) => {
                    if (String(e.target?.value).length > 0) {
                      setDisabledNoEmp(true);
                    } else {
                      setDisabledNoEmp(false);
                    }
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="col-btns-search-usr" gutter={[16, 0]}>
            <Col>
              <Form.Item style={{ margin: 0 }}>
                <Button className="btn-default" text="Limpiar" onClick={onLimpiar} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item style={{ margin: 0 }}>
                <Button type="primary" htmlType="submit" text="Buscar" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </section>
      {rolValue && rolValue.includes('SIF.REPRESENTANTEFINANZA') && (
        <div className="div-noasignado">
          <ExclamationCircleFilled style={{ color: '#faad14', fontSize: '26px' }} />
          <h3 style={{ marginLeft: '10px' }}>
            Este usuario ya cuenta con asignación desde el Sistema Integral de Fiscalización
          </h3>
        </div>
      )}
      {isVisibleCard ? (
        <section className="section-card">
          <div className="img-card">
            {loadingCard ? (
              <Skeleton avatar />
            ) : (
              <img
                src={dataUserImg}
                style={{ height: '110px', width: '110px', marginRight: '1px' }}
                alt="Imagen usuario"
              />
            )}
          </div>
          <div className="div-card-info-user">
            <Card
              bordered={false}
              loading={loadingCard}
              style={{
                width: 500
              }}>
              <div className="row-card-p">
                <p className="p-data-card">No. de empleado: </p>
                <p style={{ margin: '0' }}>{usuarioLdap ? usuarioLdap.claveEmpleado : ''}</p>
              </div>
              <div className="row-card-p">
                <p className="p-data-card">Usuario: </p>
                <p style={{ margin: '0' }}>{usuarioLdap ? usuarioLdap.usuario : ''}</p>
              </div>
              <div className="row-card-p">
                <p className="p-data-card">Nombre: </p>
                <p style={{ margin: '0' }}>
                  {usuarioLdap ? `${usuarioLdap.nombre} ${usuarioLdap.apellidos}` : ''}
                </p>
              </div>
              <div className="row-card-p">
                <p className="p-data-card">Puesto: </p>
                <p style={{ margin: '0' }}>{usuarioLdap ? usuarioLdap.puesto : ''}</p>
              </div>
              <div className="row-card-p">
                <p className="p-data-card">Grupo: </p>
                <p style={{ margin: '0' }}>{usuarioLdap ? usuarioLdap.rol : ''}</p>
              </div>
              <div className="row-card-p">
                <p className="p-data-card">Correo electrónico: </p>
                <p style={{ margin: '0' }}>{usuarioLdap ? usuarioLdap.correo : ''}</p>
              </div>
            </Card>
          </div>
        </section>
      ) : null}
      {rolValue === 'SIMAC.VALIDADOR.OC' ||
      rolValue === 'SIMAC.CAPTURA.OC' ||
      rolValue === 'SIMAC.MOVIL.OC' ||
      rolValue === 'SIMAC.CONSULTA.OC' ||
      rolValue === 'SIMAC.MOVIL_WEB.OC' ? (
        <div>
          <Form
            id="rolSimac"
            layout="vertical"
            form={form}
            onFinish={onFinishAsigEnc}
            className="card-form">
            <Row>
              <Col span={24}>
                <h2 style={{ fontWeight: '500', color: '#494747' }}>
                  Asignación de estructura regional y monitoreos
                </h2>
              </Col>
            </Row>
            <Row className="row-form" gutter={16}>
              <Col span={9}>
                <Form.Item
                  name="estRegional"
                  label="Estructura regional:"
                  className="card-formitem"
                  rules={[{ required: true, message: 'Dato requerido.' }]}>
                  <Select
                    mode="multiple"
                    style={{ width: '94%' }}
                    allowClear
                    onChange={handleChangeEstReg}
                    filterOption={(input, option) =>
                      option.key.toLowerCase().includes(input.toLowerCase())
                    }>
                    {edosTodos?.length > 0 ? (
                      <Option id={-1} key="TODOS" value={-1}>
                        TODOS
                      </Option>
                    ) : (
                      edosNotOC.map((data, _index) => (
                        <Option id={_index} key={data.nombreEstado} value={data.idEstado}>
                          {data.nombreEstado}
                        </Option>
                      ))
                    )}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={9}>
                <Form.Item
                  name="encuesta"
                  label="Monitoreo:"
                  className="card-formitem"
                  rules={[{ required: true, message: 'Dato requerido.' }]}>
                  <Select
                    mode="multiple"
                    allowClear
                    filterOption={(input, option) =>
                      option.key.toLowerCase().includes(input.toLowerCase())
                    }>
                    {cmonitoreos
                      ? cmonitoreos.map((data) => (
                          <Option key={data.monitoreo} value={data.idCMonitoreo}>
                            {data.monitoreo}
                          </Option>
                        ))
                      : null}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item name="checkOficinas" valuePropName="checked">
                  <Checkbox>Oficinas centrales</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Row className="btns-form" gutter={16}>
              <Col>
                <Form.Item>
                  <Button className="btn-default" text="Cancelar" onClick={onCancelar} />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    text="Guardar"
                    disabled={!(edosNotOC?.length > 0) && !(cmonitoreos?.length > 0)}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      ) : null}
      <div className="div-table">
        <h2 className="title-h1" style={{ marginTop: '3px', marginBottom: '18px' }}>
          Usuarios asignados
        </h2>
        <div className="div-header-table">
          <Row style={{ width: '100%' }}>
            <Col span={12} className="col-header-table-col1">
              <span style={{ marginRight: '1%' }}>Mostrar </span>
              <Select
                placeholder="10"
                options={[
                  {
                    value: 10,
                    label: '10'
                  },
                  {
                    value: 20,
                    label: '20'
                  },
                  {
                    value: 50,
                    label: '50'
                  }
                ]}
                onChange={setValueMostrar}
                style={{
                  width: '58px',
                  marginRight: '9px',
                  borderColor: 'black'
                }}
              />
              <span style={{ marginRight: '1.5%' }}>registros</span>
              <ExcelButton type="text" disabled={downloadingExcel} onClick={handleDownloadExcel} />
            </Col>
          </Row>
        </div>
        <div className="div-table-modal">
          <ConfigProvider locale={locale}>
            <Table
              rowKey={(record) => record.idUsuario}
              bordered={false}
              loading={loading}
              columns={columns}
              dataSource={dataList || usuariosList}
              pagination={{
                position: ['bottomRight'],
                showQuickJumper: true,
                size: 'small',
                pageSize: valueMostrar,
                showTotal,
                total:
                  Object.keys(searchValue).length === 0
                    ? usuariosList.length
                    : usuariosFiltro.length
              }}
            />
            <Divider style={{ marginTop: 0, marginBottom: 0 }} />
          </ConfigProvider>
          {isModalOpen ? (
            <ModalUser
              open={isModalOpen}
              callback={() => setIsModalOpen(false)}
              user={userToEdit}
              estados={estados}
              cmonitoreos={cmonitoreos}
              rolName={rolNameRow}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default UserAccount;
